export const ToastMessages = {
  common: {
    REQUIRED_FIELDS: 'Please fill all required fields.',
    INVALID_INPUT: 'Some fields have invalid input.',
    TRY_AGAIN: 'Something went wrong. Please try again.',
    UNEXPECTED_ERROR_TRY_AGAIN: 'An unexpected error occurred. Try again later',
    SOMETHING_WENT_MISSING_TRY_AGAIN:
      'Looks like something went missing. Please refresh or try again soon.',
    FAILED_TO_SAVE_CHANGES: 'Failed to save changes',
    ERROR_OCCURRED_TRY_LATER_OR_CONTACT_ADMIN: 'Error occurred. Try again later or contact admin.',
    REQUEST_COMPLETED: 'This request has already been completed.',
  },

  verifyToken: {
    error: {
      INVALID_AUTHENTICATION: 'Invalid authentication request',
    },
  },
  onboarding: {
    success: {
      ONBOARDING_COMPLETED:
        'Great job! You have completed the onboarding assessment. Thank you for your time and effort.',
    },
  },

  checkIn: {
    success: {
      CHECK_IN_SAVED: 'Your check-in was saved — great job!',
    },
    error: {
      QUESTIONNAIRE_NOT_FOUND: 'Questionnaire not found',
      CHECK_IN_SAVE_UNSUCCESSFUL:
        'Save unsuccessful. Please try again — your progress is important...',
      ANSWER_ALL_QUESTIONS: 'Please answer all questions before submitting',
    },
  },

  priorities: {
    success: {
      PRIORITIES_SAVED_SUCCESSFULLY: 'Priorities saved successfully',
    },
    info: {
      ALL_THE_AREAS_ALREADY_ADDED: 'All the focus areas are already added',
    },
    error: {
      MAXIMUM_10_PRIORITIES: 'Maximum 10 priorities can be selected',
      CREATE_ASSESSMENT_FIRST: 'Please create an assessment first',
      ERROR_OCCURRED_WHEN_REMOVING: 'Error occurred when removing priories',
    },
  },

  journal: {
    success: {
      REFLECTION_SAVED: 'Your reflection has been saved successfully.',
      REFLECTION_SAVED_AND_SHARED:
        'Great job! Your reflection has been saved and will be shared with your organisation.',
    },
    error: {
      ERROR_SUBMITTING: 'Error submitting reflection. Try again later',
      PLEASE_ENTER_YOUR_REFLECTION: 'Please enter your reflection',
    },
  },

  questionnaireV2: {
    success: {},
    info: {},
    error: {
      QUESTIONNAIRE_IS_MISSING: 'Questionnaire is missing. Please try again!',
    },
  },

  talkToAdvisor: {
    success: {
      SUCCESSFULLY_SHARED: 'Successfully shared!',
    },
    info: {},
    error: {
      QUESTIONNAIRE_NOT_SELECTED: 'Questionnaire not selected',
    },
  },

  booking: {
    success: {
      BOOKING_SUCCESSFUL: 'Booking successful. Please check your email for more information.',
    },
    info: {},
    error: {
      BOOKING_FAILED: 'Booking failed. Please try again.',
    },
  },

  createSpeakUp: {
    success: {
      MESSAGE_SHARED_SUCCESSFULLY: 'Your message has been successfully shared',
      YOUR_THOUGHT_SAVED: 'Your thought have been saved',
    },
    error: {
      YOU_HAVE_EXCEEDED_YOUR_CREATE_SPEAK_UP_LIMIT:
        'You have sent high number of speak up messages recently. Please wait for the administrator to respond to you to be able to follow up. If you need urgent help, please click here to access urgent help resources.',
      QUESTIONNAIRE_AND_DESCRIPTION_REQUIRED: 'Questionnaire and Description are required',
      PLEASE_SELECT_QUESTION_TO_SHARE: 'Please select a question to share',
      PLEASE_ENTER_MESSAGE: 'Please enter a message',
    },
  },

  instantMessaging: {
    error: {
      WAIT_UNTIL_PREVIOUS_MESSAGE: 'Please wait until the previous message has been sent.',
    },
  },

  dashboard: {
    success: {
      DATA_FETCHED: 'Dashboard data loaded successfully.',
    },
    error: {
      DATA_FETCH_FAILED: 'Failed to load dashboard data.',
    },
  },

  experts: {
    success: {
      SESSION_CANCELLED: 'Session cancelled successfully',
    },
    error: {},
    info: {},
  },

  action: {
    success: {
      ACTION_UPDATED: 'Action updated successfully',
      ACTION_REMOVED: 'Action removed successfully',
      ACTION_CREATED: 'Action created successfully',
    },
    error: {},
    info: {},
  },

  auth: {
    success: {
      LOGIN: 'You are now logged in.',
      LOGOUT: 'You have been logged out.',
    },
    error: {
      LOGIN_FAILED: 'Invalid credentials.',
      UNAUTHORIZED: 'You are not authorized.',
    },
  },
} as const;

export type ToastSection = keyof typeof ToastMessages;
export type ToastType<T extends ToastSection> = keyof (typeof ToastMessages)[T];
